import axios from 'axios'
import { IGetVideoUrl } from './types'

const instance = axios.create({
    baseURL: 'https://st.2aw.io:8081/',
})

const authAPI = {
    getCode (email: string) {
        return instance.post(`registration?email=${email}`)
    },

    sendCode (email: string, code: string) {
        const body = JSON.stringify({ vcode: Number(code) })
        return instance.post<string, { data: { status: string, uid: string } }>(`registration?email=${email}`, body)
    },

    authMe (uid: string, sid: string) {
        const date = new Date()
        const minutes = -date.getTimezoneOffset()
        const body = JSON.stringify({
            locale: 'RU',
            time_zone: 'GMT+3',
            minutes_from_gmt: minutes,
        })
        return instance.post(`auth?uid=${uid}&sid=${sid}`, body)
    },

    restore (email: string) {
        return instance.get(`registration?email=${email}&restore`)
    },

    sendRestoreCode (email: string, code: string) {
        const body = JSON.stringify({ vcode: Number(code) })
        return instance.post<string, { data: { status: string, uid: string } }>(`registration?email=${email}&restore`, body)
    },

    getVideoUrl(tid: string) {
        return instance.get<null, IGetVideoUrl>(`excursions/video_url?tid=${tid}`)
    }
}

export default authAPI;